import { For, type JSX } from 'solid-js';
import { t } from '../i18n';
import type { KbSearchHit } from '../lib/kb';

// Repo KB tab → search results (the `kb_search` read, REST twin). Presenter.
//
// A HIT IS NOT A PAGE. It carries the server's PREVIEW excerpt — first non-empty
// line, capped — and never the body, which is what makes the search cheap and
// why opening a hit point-reads the page. So the excerpt renders as plain text,
// not through `renderMarkdown`: it is a fragment cut mid-document, and feeding
// half a fenced block to a markdown parser paints markup that is not in the page.
//
// The score is shown because ranked results with no rank are a list in an order
// nobody can explain.

export function KbSearchHits(props: {
  readonly hits: readonly KbSearchHit[];
  readonly selected: string | null;
  readonly onOpen: (slug: string) => void;
}): JSX.Element {
  return (
    <ul class="repo-kb__list">
      <For each={props.hits}>
        {(hit) => (
          <li class="row-list__row" data-slug={hit.slug}>
            <button
              type="button"
              class="repo-kb__entry"
              aria-current={props.selected === hit.slug ? 'true' : undefined}
              onClick={() => props.onOpen(hit.slug)}
            >
              <span class="repo-kb__hit-head">
                <code class="repo-kb__slug">{hit.slug}</code>
                <span class="repo-kb__score">
                  {t('repo_kb.score', { score: hit.score.toFixed(2) })}
                </span>
              </span>
              <span class="repo-kb__excerpt">{hit.excerpt}</span>
            </button>
          </li>
        )}
      </For>
    </ul>
  );
}
